import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import Element from 'element-ui';
import VueResource from 'vue-resource';
import locale from 'element-ui/lib/locale/lang/fr'
import VueSweetAlert from 'vue-sweetalert'
import VueCodeMirror from 'vue-codemirror'

window.__ = require('lodash');

import * as Components from './components';
import store from './store/store.js';

Vue.use(Vuex);
Vue.use(Element, { locale });
Vue.use(VueResource);
Vue.use(VueSweetAlert);
Vue.use(VueRouter);
Vue.use(VueCodeMirror)

Vue.prototype.$swal.setDefaults({
  reverseButtons: true,
  buttonsStyling: false,
  confirmButtonClass: 'PCR-swal-btn el-button--primary',
  cancelButtonClass: 'PCR-swal-btn swal2-styled'
});

const router = new VueRouter({
  mode: 'history'
})

const GrantLevelLabels = {
  "0": '<span class="label label-inverse">Aucune</span>',
  "8": '<span class="label label-success">Contact</span>',
  "16": '<span class="label label-primary">Viewer</span>',
  "64": '<span class="label label-info">Editeur</span>',
  "112": '<span class="label label-warning">Administrateur</span>',
  "127": '<span class="label label-important">Super administrateur</span>',
};

const GrantLevelNames = {
  "0": 'Aucune',
  "8": 'Contact',
  "16": 'Viewer',
  "64": 'Editeur',
  "112": 'Administrateur',
  "127": 'Super administrateur',
};

Vue.prototype.$grantLevel = {
  blind: 0,
  user: 8,
  viewer: 16,
  contributor: 32,
  editor: 64,
  superEditor: 80,
  administrator: 112,
  superadministrator: 127
};


function hashCode(str) { // java String#hashCode
  var hash = 0;
  for (var i = 0; i < str.length; i++) {
  hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return hash;
};
function intToRGB(i) {
  var c = (i & 0x00FFFFFF)
      .toString(16)
      .toUpperCase();

  return "00000".substring(0, 6 - c.length) + c;
};

Vue.prototype.$getComputedColor = (str) => {
  return { backgroundColor: intToRGB(hashCode(str)) };
}

Vue.prototype.$getSelectedText = () => {
  var text = "";
  if (typeof window.getSelection != "undefined") {
    text = window.getSelection().toString();
  } else if (typeof document.selection != "undefined" && document.selection.type == "Text") {
    text = document.selection.createRange().text;
  }
  return text;
};

Vue.prototype.$defaultSwalApiResponse = (response, func) => {
  if (response.ok) {
    if (func) func(response);
  }
  else {
    Vue.prototype.$swal({
      type: 'error',
      title: 'Erreur',
      html: 'Une erreur est survenue.<br />Si le problème persiste, merci de contacter un administrateur.'
    }).then(() => { });
  }
};

Vue.prototype.$linebreakToBR = (value) => {
  if(!value) return '';

  return value.replace(/(?:\r\n|\r|\n)/g, '<br />');
};

function addZero(i) {
    if (i < 10) {
        i = "0" + i;
    }
    return i;
}

Vue.prototype.$humanize = (value, getTime) => {
  if (!value) return '';

  let d = new Date(parseInt(value.replace("/Date(", "").replace(")/", ""), 10));

  let month = String(d.getMonth() + 1);
  let day = String(d.getDate());
  const year = String(d.getFullYear());

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  if(getTime) {
    var hours = addZero(d.getHours());
    var minutes = addZero(d.getMinutes());
    var seconds = addZero(d.getSeconds());

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  }

  return `${day}/${month}/${year}`;
};

import * as diacritics from 'diacritics';
Vue.prototype.$normalizeString = (value) => {
  if(!value) return '';
  return diacritics.remove(value).toLowerCase().trim();
};


// This is a global mixin, it is applied to every vue instance
Vue.mixin({
  data: function () {
    return {
      get GrantLevelLabels() {
        return GrantLevelLabels;
      },
      get GrantLevelNames() {
        return GrantLevelNames;
      }
    }
  },
  filters: {
    humanize: function (value) {
      return Vue.prototype.$humanize(value);
    }
  }
})

new Vue({
  el: '#app-PCR',
  router,
  store,
  components: Components,
  created() {
    this.$http.get('/api/user').then((response) => {
      Vue.prototype.$user = response.data;
    });
  }
});

window['MountVue'] = function (selector) {
  new Vue({
    el: selector,
    components: Components
  });
};



// WEBPACK FOOTER //
// ./src/main.js